import { Col, Select } from "antd";
import { IFundsSourceField } from "./IFundsSourceField";

const { Option } = Select;

const FundsSourceField = ({
	value,
	fieldName,
	index,
	translations,
	canonicalValues,
	errors,
	handleSelectOrDatePicker,
	disabled = false,
}: IFundsSourceField) => (
	<Col xs={24} md={12} lg={12} className="titles">
		<label className="required"> {translations.fundSources} </label>
		<Select
			className="input-field"
			value={value ? value.split(';') : []}
			disabled={disabled}
			onChange={(values: string[]) => handleSelectOrDatePicker(fieldName, index || 0)(values.join(';'))}
			mode="multiple"
			status={errors[index].source ? 'error' : ''}
			placeholder={translations.seleccioneOpcion}
		>
			{translations.sourceOptions.map((option: string, idx: number) => (
				<Option key={idx} value={canonicalValues?.[idx] || option}>{option}</Option>
			))}
		</Select>
		<span className={`error ${errors[index].source ? 'show' : null}`}>{translations.seleccioneOpcion}</span>
	</Col>
);

export default FundsSourceField;
